/**
 * Builds a GA4 "items" array from the checkout Vuex store's productData.products
 * (keyed 'product_<order_line_id>'), which Step::getCartItems() populates with
 * product_id / item_category / item_category2 / item_brand alongside price data.
 * @param {Object} products
 * @returns {Array}
 */
export function buildCartGtmItems(products) {
    if (!products) {
        return [];
    }

    return Object.values(products).map(function (p, index) {
        return {
            item_id: p.product_id,
            item_name: p.name,
            affiliation: 'Webshop',
            index: index,
            item_brand: p.item_brand || '',
            item_category: p.item_category || '',
            item_category2: p.item_category2 || '',
            item_category3: '',
            item_category4: '',
            item_list_id: p.item_list_id || '',
            item_list_name: p.item_list_name || '',
            price: Number(p.quantity ? (p.gross_price / p.quantity) : p.gross_price),
            google_business_vertical: 'retail',
            quantity: Number(p.quantity),
        };
    });
}

/**
 * Pushes a GA4 ecommerce event to window.dataLayer, clearing the previous
 * ecommerce object first as required by GTM/GA4 conventions.
 * @param {string} event
 * @param {Object} ecommerce
 * @param {Object} [extra] extra top-level fields (e.g. email, user_id)
 */
export function pushEcommerceEvent(event, ecommerce, extra) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push(Object.assign({ event: event, ecommerce: ecommerce }, extra || {}));
}
